export const cleanText = (text) => {
    text = text.replace(/<p>/g, "")
    text = text.replace(/<\/p>/g, "\n")
    text = text.replace(/<br\/>/g, "\n\n")
    return text
}
